package com.tovtalk.ui.components

import androidx.compose.material3.AlertDialog
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.tovtalk.ui.theme.TovTalkTheme
import com.tovtalk.utils.strings.StringKeys
import com.tovtalk.utils.strings.StringProvider

/**
 * Dialog shown when an action is blocked due to kashrut level (follow, chat, view post).
 * Only read-only users can change kashrut; for others we show message + Cancel only.
 */
@Composable
fun KashrutRestrictionDialog(
    message: String?,
    onDismiss: () -> Unit,
    onGoToSettings: (() -> Unit)?,
    modifier: Modifier = Modifier
) {
    AlertDialog(
        onDismissRequest = onDismiss,
        title = {
            Text(
                text = StringProvider.get(StringKeys.KASHRUT_DIALOG_TITLE),
                style = TovTalkTheme.typography.titleMedium,
                color = TovTalkTheme.colors.textPrimary
            )
        },
        text = {
            Text(
                text = message ?: StringProvider.get(StringKeys.KASHRUT_DIALOG_MESSAGE),
                style = TovTalkTheme.typography.bodyMedium,
                color = TovTalkTheme.colors.textSecondary
            )
        },
        confirmButton = {
            onGoToSettings?.let { goTo ->
                TextButton(onClick = goTo) {
                    Text(
                        text = StringProvider.get(StringKeys.KASHRUT_GO_TO_SETTINGS),
                        color = TovTalkTheme.colors.brand
                    )
                }
            }
        },
        dismissButton = {
            TextButton(onClick = onDismiss) {
                Text(
                    text = StringProvider.get(StringKeys.KASHRUT_DIALOG_CANCEL),
                    color = TovTalkTheme.colors.textSecondary
                )
            }
        },
        modifier = modifier
    )
}
